import { useMemo } from 'react'
import { useGetData } from 'src/hooks/useGetData'
import userApi from 'src/api/userApi'
import { createUserOption } from 'src/libs/util'
import { isArray } from 'lodash'

export function useGetUserOptionsByRole (roleName, options = { isIncludesUserLocked: false }) {
  const { data: users } = useGetData(userApi.searchByRole, roleName)
  const { data: usersLocked } = useGetData(userApi.searchByRoleLocked, roleName, { isDisabled: !options?.isIncludesUserLocked })

  return useMemo(() => {
    let preparedListUsers;
    if (isArray(users) && users.length) {
      preparedListUsers = users;
    }
    if (isArray(usersLocked) && usersLocked?.length) {
      preparedListUsers = (preparedListUsers || []).concat(usersLocked)
    }
    return preparedListUsers ? createUserOption(preparedListUsers) : []
    
  }, [users, usersLocked])
}
